import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const RegChangeHubPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.RegChangeHubPage }))
)
const RegChangeAlertsPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.RegChangeAlertsPage }))
)
const RegChangeImpactsPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.RegChangeImpactsPage }))
)
const ImpactAnalysisPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.ImpactAnalysisPage }))
)
const RegChangeActionsPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.RegChangeActionsPage }))
)
const ObligationManagementPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.ObligationManagementPage }))
)
const RegulatoryHorizonPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.RegulatoryHorizonPage }))
)
const RegChangeAuditTrailPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.RegChangeAuditTrailPage }))
)
const RegChangeSettingsPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.RegChangeSettingsPage }))
)
// M13 Continuous Watch (veille)
const WatchKpisPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.WatchKpisPage }))
)
const TechExposuresPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.TechExposuresPage }))
)
const LegalProposalsPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.LegalProposalsPage }))
)
const WatchDigestPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.WatchDigestPage }))
)
const PackChangeRequestsPage = lazy(() =>
  import('../pages/reg-change').then((m) => ({ default: m.PackChangeRequestsPage }))
)
// Living regulatory feed (watch-source bootstrap + ingest) — page lives in compliance-pro
const RegFeedPage = lazy(() =>
  import('../pages/compliance-pro').then((m) => ({ default: m.RegFeedPage }))
)

export const regChangeRoutes: RouteObject[] = [
  {
    path: '/reg-change',
    children: [
      { index: true, element: <RegChangeHubPage /> },
      { path: 'hub', element: <RegChangeHubPage /> },
      { path: 'alerts', element: <RegChangeAlertsPage /> },
      { path: 'impacts', element: <RegChangeImpactsPage /> },
      { path: 'impact-analysis', element: <ImpactAnalysisPage /> },
      { path: 'actions', element: <RegChangeActionsPage /> },
      { path: 'obligations', element: <ObligationManagementPage /> },
      { path: 'feed', element: <RegFeedPage /> },
      { path: 'horizon', element: <RegulatoryHorizonPage /> },
      { path: 'audit-trail', element: <RegChangeAuditTrailPage /> },
      { path: 'settings', element: <RegChangeSettingsPage /> },
      // M13 Continuous Watch (veille)
      { path: 'watch-kpis', element: <WatchKpisPage /> },
      { path: 'tech-exposures', element: <TechExposuresPage /> },
      { path: 'legal-proposals', element: <LegalProposalsPage /> },
      { path: 'digests', element: <WatchDigestPage /> },
      { path: 'pack-changes', element: <PackChangeRequestsPage /> },
    ],
  },
]
